import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-540e7e69"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = ["href", "onClick"]
const _hoisted_4 = { class: "card_text_and_image_wrapper" }
const _hoisted_5 = { class: "custom-list" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Land:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Närmaste tågstation:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vattenkvalitet:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Strandtyp:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Mat och dryck:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Känd för:", -1))
const _hoisted_12 = { class: "custom-list" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Land: ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Närmaste tågstation:", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vattenkvalitet:", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Strandtyp:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Mat och dryck:", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Känd för:", -1))
const _hoisted_19 = { class: "custom-list" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Land: ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Närmaste tågstation:", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vattenkvalitet:", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Strandtyp:", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Mat och dryck:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Känd för:", -1))
const _hoisted_26 = { class: "custom-list" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Land: ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Närmaste tågstation:", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vattenkvalitet:", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Strandtyp:", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Mat och dryck:", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Känd för:", -1))
const _hoisted_33 = { class: "custom-list" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Land: ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Närmaste tågstation:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vattenkvalitet:", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Strandtyp:", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Mat och dryck:", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Känd för:", -1))
const _hoisted_40 = { class: "custom-list" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Land: ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Närmaste tågstation:", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vattenkvalitet:", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Strandtyp:", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Mat och dryck:", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Känd för:", -1))
const _hoisted_47 = { class: "custom-list" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Land: ", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, " Närmaste tågstation: Bodø (därefter färja och buss till Lofoten) ", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vattenkvalitet:", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Strandtyp:", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Mat och dryck:", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Känd för:", -1))
const _hoisted_54 = { class: "custom-list" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Land: ", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Närmaste tågstation:", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vattenkvalitet:", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Strandtyp:", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Mat och dryck:", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Känd för:", -1))
const _hoisted_61 = { class: "custom-list" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Land: ", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, " Närmaste tågstation: Split (därefter färja till Brač och buss till Bol) ", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vattenkvalitet:", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Strandtyp:", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Mat och dryck:", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, " Känd för: Sin unika spetsform som förändras beroende på strömmarna. En av Europas mest ikoniska stränder med otroligt vackert vatten och en perfekt plats för vindsurfing. ", -1))
const _hoisted_68 = { class: "custom-list" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Land: ", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Närmaste tågstation:", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vattenkvalitet:", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Strandtyp:", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, " Mat och dryck: Gott om restauranger och kaféer längs strandpromenaden ", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Känd för:", -1))
const _hoisted_75 = { class: "custom-list" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Land: ", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Närmaste tågstation:", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vattenkvalitet:", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Strandtyp:", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Mat och dryck:", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Känd för:", -1))

import { ref, defineComponent } from "vue"; // Ensure this import is present
import TextBlock from "../../blocks/TextBlock.vue";
import ContentWrapper from "../../generics/ContentWrapper.vue";
import PageTitle from "../../blocks/PageTitle.vue";
import CustomPic from "../../generics/CustomPic.vue";
import flagIcon from "../../../assets/SVG/flagIcon.vue";
import trainIcon from "../../../assets/SVG/trainIcon.vue";
import waterIcon from "../../../assets/SVG/waterIcon.vue";
import landscapeIcon from "../../../assets/SVG/landscapeIcon.vue";
import starIcon from "../../../assets/SVG/starIcon.vue";
import restaurantIcon from "../../../assets/SVG/restaurantIcon.vue";
import meta from "@/data/meta.json";
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker, LPopup } from "@vue-leaflet/vue-leaflet";
import L from "leaflet"; // Import Leaflet for custom icons


export default /*#__PURE__*/_defineComponent({
  __name: 'BeachGuide',
  setup(__props) {

defineComponent({
	components: {
		LMap,
		LTileLayer,
		LMarker,
		LPopup,
	},
});

const beaches = ref([
	{
		id: 1,
		name: "Tropea Beach",
		country: "Italien",
		lat: 38.6762,
		lon: 15.8984,
		link: "#tropea",
	},
	{
		id: 2,
		name: "Praia da Falésia",
		country: "Portugal",
		lat: 37.0891,
		lon: -8.1698,
		link: "#falesia",
	},
	{
		id: 3,
		name: "Sveti Stefan",
		country: "Montenegro",
		lat: 42.2569,
		lon: 18.896,
		link: "#sveti-stefan",
	},
	{
		id: 4,
		name: "Île de Porquerolles",
		country: "Frankrike",
		lat: 43.0036,
		lon: 6.2148,
		link: "#porquerolles",
	},
	{
		id: 5,
		name: "Praia da Nazaré",
		country: "Portugal",
		lat: 39.6022,
		lon: -9.0703,
		link: "#nazare",
	},
	{
		id: 6,
		name: "Barafundle Bay",
		country: "Storbritannien",
		lat: 51.6271,
		lon: -4.9123,
		link: "#barafundle",
	},
	{
		id: 7,
		name: "Hauklandstranda",
		country: "Norge",
		lat: 68.1532,
		lon: 13.6017,
		link: "#hauklandstranda",
	},
	{
		id: 8,
		name: "Praia da Arrifana & Praia de Monte Clérigo",
		country: "Portugal",
		lat: 37.292089,
		lon: -8.864528,
		link: "#arrifana-clerigo",
	},
	{
		id: 9,
		name: "Zlatni Rat",
		country: "Kroatien",
		lat: 43.256508,
		lon: 16.633956,
		link: "#zlatni-rat",
	},
	{
		id: 10,
		name: "Biarritz",
		country: "Frankrike",
		lat: 43.487559,
		lon: -1.556521,
		link: "#biarrritz",
	},
	{
		id: 11,
		name: "Galebove stijene & Rt Kamenjak",
		country: "Kroatien",
		lat: 44.861023,
		lon: 13.805323,
		link: "#kamenjak",
	},
]);

// Function to create a custom numbered marker
const createNumberedIcon = (number: number) => {
	return L.divIcon({
		className: "custom-icon",
		html: `<div class="marker-icon">${number}</div>`,
		iconSize: [30, 30], // Adjust size as needed
		iconAnchor: [15, 30], // Center the icon
	});
};

const scrollToSection = (id: string) => {
	const section = document.querySelector(id);
	if (section) {
		section.scrollIntoView({ behavior: "smooth" });
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).beachGuide), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "De bästa stränderna i Europa som du kan nå med tåg",
      backgroundImageClass: "background-sveti-stefan"
    }),
    _createVNode(ContentWrapper, null, {
      default: _withCtx(() => [
        _createVNode(TextBlock, {
          "header-tag": "h2",
          header: "\n            Till alla er som inte vet något bättre än en heldag på stranden. Om det så innebär att bada, hoppa från klippor, surfa, sola, sippa på en drink eller ligga under parasollet med en bok i handen. Här är vår top 10 guide!"
        }),
        _createElementVNode("div", null, [
          _createVNode(_unref(LMap), {
            zoom: 3.5,
            center: [56.0, 10.0],
            style: {"height":"700px","width":"100%","border-radius":"12px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(LTileLayer), {
                url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
                attribution: "© <a href='https://www.openstreetmap.org/copyright'>OSM</a> © <a href='https://carto.com/'>CARTO</a>"
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(beaches.value, (beach) => {
                return (_openBlock(), _createBlock(_unref(LMarker), {
                  key: beach.id,
                  "lat-lng": [beach.lat, beach.lon]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(LPopup), null, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", null, _toDisplayString(beach.id) + ". " + _toDisplayString(beach.name), 1),
                        _hoisted_1,
                        _createTextVNode(" " + _toDisplayString(beach.country), 1),
                        _hoisted_2,
                        _createElementVNode("a", {
                          href: beach.link,
                          onClick: _withModifiers(($event: any) => (scrollToSection(beach.link)), ["prevent"])
                        }, "Mer info", 8, _hoisted_3)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["lat-lng"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["zoom", "center"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(TextBlock, { header: "Ta tåget till Europas bästa stränder" }, {
            default: _withCtx(() => [
              _createTextVNode(" Gå igenom vår lista av de allra bästa stränderna i Europa som du dessutom kan nå enkelt med tåget. Oavsett om det är klippor, sand, kallt eller varmt; dessa får du inte missa! ")
            ]),
            _: 1
          }),
          _createVNode(CustomPic, {
            picturePath: "pictures/tropea-italy.jpg",
            id: "tropea"
          }),
          _createVNode(TextBlock, { header: "1. Tropea Beach, Italien" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_5, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(flagIcon))),
                  _hoisted_6,
                  _createTextVNode(" Italien")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(trainIcon))),
                  _hoisted_7,
                  _createTextVNode(" Tropea ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(waterIcon))),
                  _hoisted_8,
                  _createTextVNode(" Kristallklart ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(landscapeIcon))),
                  _hoisted_9,
                  _createTextVNode(" Sandstrand med dramatiska klippformationer ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _hoisted_10,
                  _createTextVNode(" Restauranger och kaféer i närheten ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(starIcon))),
                  _hoisted_11,
                  _createTextVNode(" Sin fantastiska utsikt och charmiga kuststad som ger en kombinationen av historiska byggnader och enastående naturlig skönhet. ")
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(CustomPic, {
            picturePath: "pictures/praia-da-falesia-portugal.jpg",
            id: "falesia"
          }),
          _createVNode(TextBlock, { header: "2. Praia da Falésia, Portugal" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_12, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(flagIcon))),
                  _hoisted_13,
                  _createTextVNode("Portugal")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(trainIcon))),
                  _hoisted_14,
                  _createTextVNode(" Loule ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(waterIcon))),
                  _createTextVNode(),
                  _hoisted_15,
                  _createTextVNode(" Kristallklart ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(landscapeIcon))),
                  _createTextVNode(),
                  _hoisted_16,
                  _createTextVNode(" Lång sandstrand omgiven av röda klippor ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _createTextVNode(),
                  _hoisted_17,
                  _createTextVNode(" Restauranger, caféer och barer i närheten ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(starIcon))),
                  _createTextVNode(),
                  _hoisted_18,
                  _createTextVNode(" Sin spektakulära natur och fantastiska solnedgångar. Den dramatiska kontrasten mellan de röda klipporna och det turkosa vattnet. ")
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(CustomPic, {
            picturePath: "pictures/sveti-stefan.jpg",
            id: "sveti-stefan"
          }),
          _createVNode(TextBlock, { header: "3. Sveti Stefan, Montenegro" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_19, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(flagIcon))),
                  _hoisted_20,
                  _createTextVNode("Montenegro ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(trainIcon))),
                  _hoisted_21,
                  _createTextVNode(" Bar (därefter 30 min buss eller taxi) ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(waterIcon))),
                  _createTextVNode(),
                  _hoisted_22,
                  _createTextVNode(" Kristallklart ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(landscapeIcon))),
                  _hoisted_23,
                  _createTextVNode(" Småsten och sand ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _hoisted_24,
                  _createTextVNode(" Lyxiga restauranger och kaféer ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(starIcon))),
                  _createTextVNode(),
                  _hoisted_25,
                  _createTextVNode(" Lyxig resort och otrolig skönhet. En av de mest exklusiva stranddestinationerna i Europa. ")
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(CustomPic, {
            picturePath: "pictures/porquerolles.jpg",
            id: "porquerolles"
          }),
          _createVNode(TextBlock, { header: "4. Île de Porquerolles, Frankrike " }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_26, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(flagIcon))),
                  _hoisted_27,
                  _createTextVNode(" Frankrike ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(trainIcon))),
                  _hoisted_28,
                  _createTextVNode(" Toulon (därefter färja) ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(waterIcon))),
                  _hoisted_29,
                  _createTextVNode(" Kristallklart ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(landscapeIcon))),
                  _hoisted_30,
                  _createTextVNode(" Sandstränder med medelhavskänsla ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _hoisted_31,
                  _createTextVNode(" Restauranger i byn ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(starIcon))),
                  _hoisted_32,
                  _createTextVNode(" Sin orörda natur och bilfria miljö. En perfekt tillflyktsort med några av Frankrikes vackraste stränder. ")
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(CustomPic, {
            picturePath: "pictures/nazare-portugal.jpg",
            id: "nazare"
          }),
          _createVNode(TextBlock, { header: "5. Praia de Nazare, Portugal" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_33, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(flagIcon))),
                  _hoisted_34,
                  _createTextVNode(" Portugal")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(trainIcon))),
                  _hoisted_35,
                  _createTextVNode(" Valado - Nazare - Alcobaca ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(waterIcon))),
                  _hoisted_36,
                  _createTextVNode(" Klart men med kraftiga vågor ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(landscapeIcon))),
                  _hoisted_37,
                  _createTextVNode(" Lång sandstrand ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _hoisted_38,
                  _createTextVNode(" Flera restauranger och fiskbarer ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(starIcon))),
                  _hoisted_39,
                  _createTextVNode(" Jättevågor och surfing. Hem till några av världens största surfvågor. ")
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(CustomPic, {
            picturePath: "pictures/barafundleBay.jpg",
            id: "barafundle"
          }),
          _createVNode(TextBlock, { header: "6. Barafundle Bay, Storbritannien" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_40, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(flagIcon))),
                  _hoisted_41,
                  _createTextVNode(" Storbritannien ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(trainIcon))),
                  _hoisted_42,
                  _createTextVNode(" Lamphey ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(waterIcon))),
                  _hoisted_43,
                  _createTextVNode(" Mycket klart ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(landscapeIcon))),
                  _hoisted_44,
                  _createTextVNode(" Sandstrand omgiven av klippor ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _hoisted_45,
                  _createTextVNode(" Inga faciliteter, ta med egen matsäck ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(starIcon))),
                  _hoisted_46,
                  _createTextVNode(" Att vara en av Storbritanniens vackraste stränder. Avskild och naturskön med gyllene sand och klart vatten. ")
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(CustomPic, {
            picturePath: "pictures/hauklandstranda.jpg",
            id: "hauklandstranda"
          }),
          _createVNode(TextBlock, { header: "7. Hauklandstranda, Norge" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_47, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(flagIcon))),
                  _hoisted_48,
                  _createTextVNode(" Norge")
                ]),
                _hoisted_49,
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(waterIcon))),
                  _hoisted_50,
                  _createTextVNode(" Kristallklart och kallt ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(landscapeIcon))),
                  _hoisted_51,
                  _createTextVNode(" Vit sandstrand med berg i bakgrunden ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _hoisted_52,
                  _createTextVNode(" Begränsat utbud, bäst att ta med egen matsäck ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(starIcon))),
                  _hoisted_53,
                  _createTextVNode(" Sin dramatiska skönhet och vildmarkskänsla. En av Nordens vackraste stränder, perfekt för naturälskare. ")
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(CustomPic, {
            picturePath: "pictures/praia-da-arrifana.jpg",
            id: "arrifana-clerigo"
          }),
          _createVNode(TextBlock, { header: "8. Praia da Arrifana & Praia de Monte Clérigo, Portugal" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_54, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(flagIcon))),
                  _hoisted_55,
                  _createTextVNode(" Portugal")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(trainIcon))),
                  _hoisted_56,
                  _createTextVNode(" Lagos (därefter buss i 1 timme) ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(waterIcon))),
                  _hoisted_57,
                  _createTextVNode(" Mycket klart, rent och friskt ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(landscapeIcon))),
                  _hoisted_58,
                  _createTextVNode(" Sandstrand med höga klippor ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _hoisted_59,
                  _createTextVNode(" Restauranger i närheten ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(starIcon))),
                  _hoisted_60,
                  _createTextVNode(" Fantastisk surf och naturskönhet. En av de vackraste surfstränderna i Portugal med en perfekt blandning av avkoppling och äventyr. ")
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(CustomPic, {
            picturePath: "pictures/zlatni-rat.jpg",
            id: "zlatni-rat"
          }),
          _createVNode(TextBlock, { header: "9. Zlatni Rat, Kroatien" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_61, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(flagIcon))),
                  _hoisted_62,
                  _createTextVNode(" Kroatien")
                ]),
                _hoisted_63,
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(waterIcon))),
                  _hoisted_64,
                  _createTextVNode(" Kristallklart ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(landscapeIcon))),
                  _hoisted_65,
                  _createTextVNode(" Små vita stenar ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _hoisted_66,
                  _createTextVNode(" Flera strandbarer och restauranger ")
                ]),
                _hoisted_67
              ])
            ]),
            _: 1
          }),
          _createVNode(CustomPic, {
            picturePath: "pictures/biarritz.jpg",
            id: "biarritz"
          }),
          _createVNode(TextBlock, { header: "10. Biarritz Grande Plage, Frankrike" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_68, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(flagIcon))),
                  _hoisted_69,
                  _createTextVNode(" Frankrike ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(trainIcon))),
                  _hoisted_70,
                  _createTextVNode(" Biarritz ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(waterIcon))),
                  _hoisted_71,
                  _createTextVNode(" Rent men ofta med starka vågor ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(landscapeIcon))),
                  _hoisted_72,
                  _createTextVNode(" Gyllene sand ")
                ]),
                _hoisted_73,
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(starIcon))),
                  _hoisted_74,
                  _createTextVNode(" Surfing och en elegant atmosfär. Kombinationen av surfkultur och fransk lyx gör denna strand unik. ")
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(CustomPic, {
            picturePath: "pictures/galebove-stijene-croatia.jpg",
            id: "kamenjak"
          }),
          _createVNode(TextBlock, { header: "11. Galebove stijene / Rt Kamenjak, Kroatien" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_75, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(flagIcon))),
                  _hoisted_76,
                  _createTextVNode(" Kroatien")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(trainIcon))),
                  _hoisted_77,
                  _createTextVNode(" Pula (därefter buss eller cykel) ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(waterIcon))),
                  _hoisted_78,
                  _createTextVNode(" Kristallklart och turkost ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(landscapeIcon))),
                  _hoisted_79,
                  _createTextVNode(" Klippor och små vikar ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(restaurantIcon))),
                  _hoisted_80,
                  _createTextVNode(" Strandbarer och enklare restauranger ")
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(starIcon))),
                  _hoisted_81,
                  _createTextVNode(" Snorkling, klippdykning och vild natur. Oslagbart klart vatten och avskildhet i en vacker nationalpark. ")
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Ta tåget till Europas stränder" }, {
            default: _withCtx(() => [
              _createTextVNode(" Med Interrail kan du enkelt nå dessa stränder och uppleva några av Europas vackraste kustlinjer utan att behöva flyga. Oavsett om du söker avkoppling, surfvågor eller unika naturupplevelser, finns det en strand för dig på denna lista! ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})